import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const ADD_GROUP = 'add group'
export const NAME = 'name'
export const CURRENCY = 'currency'
export const EDIT = 'edit'
export const RATE_CARDS = 'rate cards'

export default {
  [PORTUGUESE]: {
    [ADD_GROUP]: 'Adicionar Grupo',
    [NAME]: 'Nome',
    [CURRENCY]: 'Moeda',
    [EDIT]: 'Editar',
    [RATE_CARDS]: 'Tabelas de Preços',
  },

  [ENGLISH]: {
    [ADD_GROUP]: 'Add Group',
    [NAME]: 'Name',
    [CURRENCY]: 'Currency',
    [EDIT]: 'Edit',
    [RATE_CARDS]: 'Rate Cards',
  },

  [SPANISH]: {
    [ADD_GROUP]: 'Añadir Grupo',
    [NAME]: 'Nombre',
    [CURRENCY]: 'la Moneda',
    [EDIT]: 'Editar',
    [RATE_CARDS]: 'Tarjetas de Tarifas',
  },
}
